import React from 'react';
import {NavLink, useLocation} from 'react-router-dom';
import {navigation} from '../constants/menu';
import {classNames} from '@utils/class-names';
import LogoutButton from '../../features/auth/components/logout-button';
import Logo from "@common/components/logo";
import {ReactComponent as ChevronIcon} from "@assets/icons/chevron.svg";
import LogoutConfirmModal from "./logout-confirm-modal";

const MainMenu: React.FC = () => {
    const location = useLocation();

    const determineIsActive = (
        itemHref: string,
        locationPathname: string,
        navigationItems: typeof navigation
    ): boolean => {
        const matchingNavItems = navigationItems.filter(navItem =>
            locationPathname.startsWith(navItem.href)
        );

        if (matchingNavItems.length === 0) {
            return false;
        }

        const mostSpecificNavItem = matchingNavItems.reduce((prev, current) =>
            prev.href.length > current.href.length ? prev : current
        );

        return itemHref === mostSpecificNavItem.href;
    };

    return (
        <div className="flex flex-col gap-4 h-full w-fit bg-surface-level-2 text-white border-r border-outline-mild">
            <div className="pl-8 pr-6 border-b border-outline-mild h-[72px] flex items-center">
                <Logo/>
            </div>

            <nav className="px-6 space-y-2">
                {navigation.map((item) => {
                        const isActive = determineIsActive(item.href, location.pathname, navigation);
                        return (
                            <NavLink
                                key={item.href}
                                to={item.href}
                                className={classNames(
                                    'flex items-center p-2 w-[300px] text-on-surface rounded-lg transition-colors duration-200',
                                    isActive ? 'bg-[#1665691A]' : ''
                                )}
                            >
                                <item.Icon className="mr-3"/>
                                <span className="font-semibold text-[1rem] mr-auto">{item.name}</span>
                                <ChevronIcon className="text-on-surface/40"/>
                            </NavLink>
                        )
                    }
                )}
                <LogoutButton/>
            </nav>
            <LogoutConfirmModal/>
        </div>
    );
};

export default MainMenu;
